"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var types_1 = require("./types");
var helpers_1 = require("../helpers");
var sanitizeURL_1 = require("../helpers/sanitizeURL");
exports.calcSize = function (size) {
    switch (size) {
        case types_1.ICON_SIZES.xxs:
            return helpers_1.SIZE_XXS;
        case types_1.ICON_SIZES.xs:
            return helpers_1.SIZE_XS;
        case types_1.ICON_SIZES.s:
            return helpers_1.SIZE_S;
        case types_1.ICON_SIZES.m:
            return helpers_1.SIZE_M;
        case types_1.ICON_SIZES.l:
            return helpers_1.SIZE_L;
        case types_1.ICON_SIZES.xl:
            return helpers_1.SIZE_XL;
        case types_1.ICON_SIZES.xxl:
            return helpers_1.SIZE_XXL;
        case types_1.ICON_SIZES.xxxl:
            return helpers_1.SIZE_XXXL;
        default:
            return helpers_1.SIZE_M;
    }
};
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-shrink: 0;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    min-width: ", ";\n    min-height: ", ";\n    overflow: hidden;\n\n    svg {\n        display: block;\n        width: 100%;\n        height: 100%;\n    }\n\n    ", "\n"], ["\n    flex-shrink: 0;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: ", ";\n    height: ", ";\n    min-width: ", ";\n    min-height: ", ";\n    overflow: hidden;\n\n    svg {\n        display: block;\n        width: 100%;\n        height: 100%;\n    }\n\n    ",
    "\n"])), function (_a) {
    var size = _a.size;
    return exports.calcSize(size);
}, function (_a) {
    var size = _a.size;
    return exports.calcSize(size);
}, function (_a) {
    var size = _a.size;
    return exports.calcSize(size);
}, function (_a) {
    var size = _a.size;
    return exports.calcSize(size);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            filter: grayscale(100%);\n            opacity: 0.5;\n        "], ["\n            filter: grayscale(100%);\n            opacity: 0.5;\n        "])));
});
var Image = styled_components_1.default.i(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: block;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: contain;\n\n    ", "\n"], ["\n    display: block;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: contain;\n\n    ",
    "\n"])), function (_a) {
    var src = _a.src;
    return (typeof src === 'string' ? "url(" + src + ")" : '');
}, function (_a) {
    var size = _a.size;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: ", ";\n        min-height: ", ";\n        height: ", ";\n    "], ["\n        width: ", ";\n        min-height: ", ";\n        height: ", ";\n    "])), exports.calcSize(size), exports.calcSize(size), exports.calcSize(size));
});
exports.Icon = helpers_1.createUIElement('Icon', function (_a, ref) {
    var _b;
    var className = _a.className, src = _a.src, error = _a.error, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? types_1.ICON_SIZES.m : _d, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, onFocus = _a.onFocus, onBlur = _a.onBlur, style = _a.style, rest = __rest(_a, ["className", "src", "error", "disabled", "size", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "onFocus", "onBlur", "style"]);
    if (src && react_1.default.isValidElement(src) && src.type && src.type['__IS_ICON__']) {
        return react_1.default.cloneElement(src, __assign(__assign({}, rest), { ref: ref, className: "vm-Icon " + className, error: error,
            disabled: disabled,
            size: size,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            onKeyPress: onKeyPress,
            onFocus: onFocus,
            onBlur: onBlur,
            style: style }));
    }
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { className: "vm-Icon " + className, disabled: disabled, size: size, "data-icon": true, "data-selector-id": rest['data-selector-id'] || 'icon', onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, onFocus: onFocus, onBlur: onBlur, ref: ref, style: style }), typeof src === 'string' ? (react_1.default.createElement(Image, { "data-selector-id": "icon-image", src: sanitizeURL_1.sanitizeURL(src), size: size })) : (react_1.default.isValidElement(src) &&
        react_1.default.cloneElement(src, __assign({ error: error }, (_b = {}, _b['data-selector-id'] = 'icon-svg', _b))))));
});
exports.Icon['__IS_ICON__'] = true;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Icon.js.map